module.exports = __webpack_public_path__ + "img/T2B_xh_3.167382c9.png";